"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseConfig = void 0;
const browser_1 = require("@sentry/browser");
const integrations_1 = require("@sentry/integrations");
const EXTRA_KEY = 'ROUTE_TO';
exports.baseConfig = {
    maxBreadcrumbs: 50,
    replaysOnErrorSampleRate: 1,
    integrations: [new browser_1.ModuleMetadata(), new integrations_1.HttpClient(), new browser_1.BrowserTracing()],
    denyUrls: [
        // Ignore Google flakiness
        /\/(gtm|ga|analytics|gaconnector)\.js/i
    ],
    // Micro-frontend configurations
    transport: (0, browser_1.makeMultiplexedTransport)(browser_1.makeFetchTransport, (args) => {
        const event = args.getEvent();
        if (event &&
            event.extra &&
            EXTRA_KEY in event.extra &&
            Array.isArray(event.extra[EXTRA_KEY])) {
            return event.extra[EXTRA_KEY];
        }
        return [];
    }),
    beforeSend: (event) => {
        var _a, _b, _c;
        if ((_c = (_b = (_a = event === null || event === void 0 ? void 0 : event.exception) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b[0].stacktrace) === null || _c === void 0 ? void 0 : _c.frames) {
            const frames = event.exception.values[0].stacktrace.frames;
            // Find the last frame with module metadata containing a DSN
            const lastFrame = [...frames]
                .reverse()
                .find((frame) => frame.module_metadata && frame.module_metadata.dsn);
            if (lastFrame) {
                event.extra = {
                    ...event.extra,
                    [EXTRA_KEY]: [lastFrame.module_metadata]
                };
            }
        }
        return event;
    }
};
//# sourceMappingURL=config.js.map